import { callGetApiToServer } from "../callApi";

export async function getAllCompanyCard(
  authtoken,
  skipNumber,
  limitNumber,
  companyId,
  cardType
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl =
      "v1/auth/list-company-card/" +
      skipNumber +
      "/" +
      limitNumber +
      "/" +
      companyId;

    if (cardType && cardType !== "all") {
      endUrl = `${endUrl}?card_type=${encodeURIComponent(cardType)}`;
    }

    console.log("endUrl printed here", endUrl);

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
